export * from './card-seven-button-output.interface';
